import Breadcrumb from '../Component/Breadcrumb'
const Ptm = () => {
    return (
        <>
            <Breadcrumb breadtitle="Parent Teacher Meeting" breadmid="Academic" breadend="PTM" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className='maintitle'>Parent Teacher Meeting</h2>
                           <h4><span>Parent-Teacher meetings are organized monthly to promote the growth of the Students.</span></h4>
                           <h4><span>Parent-Teacher meetings are compulsory. Parents should co-operate with the teacher for the integral growth and progress of the student, Parents should come for the Parent-Teacher meeting along with their wards.</span></h4>
                           <h4><span>Assessment copies will be shown on these days. Parents will not meet the teachers at any other time during school hours, except when it is necessitated due to serious reasons, with the permission of the Principal.</span></h4>                            
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
export default Ptm